import { gql } from "@apollo/client";

import {
  BANK_ACCOUNT_FRAGMENT,
  BANK_LINK_FRAGMENT,
  BENEFICIARIES_FRAGMENT,
  USER_FRAGMENT,
} from "@graphql/fragments";

export const USER = gql`
  ${USER_FRAGMENT}
  ${BENEFICIARIES_FRAGMENT}
  ${BANK_LINK_FRAGMENT}
  ${BANK_ACCOUNT_FRAGMENT}

  query user {
    user {
      ...UserFragment
    }
    beneficiaries {
      ...BeneficiariesFragment
    }
    getBankLinks {
      ...BankLinkFragment
    }
    getBankAccounts {
      ...BankAccountFragment
    }
  }
`;

export const INDUSTRIES = gql`
  query industries {
    industries
  }
`;

export const OCCUPATIONS = gql`
  query occupations {
    occupations
  }
`;
